import { makeSelectors } from '@utils/css';

const contentTransitionDurationMs = 375;
const content = "z1fcn9fl1u";
const card = "z1fca3c2mr";
makeSelectors({
  content
});

export { card, content, contentTransitionDurationMs };
import "./comp.router.style.linaria.module.css";
//# sourceMappingURL=comp.router.style.js.map
